<template>
    <div class="preview_page">
        <el-dialog :visible.sync="dialogVisible" width="80%" center :modal-append-to-body="false" :close-on-click-modal="false" append-to-body @close="closeDialog">
            <div class="preview_content">
                <div class="content_top">
                    <p class="risk_txt">立案风险：</p>
                    <p :class="{ errorTxt: riskCardActiveIndex == 0, warningTxt: riskCardActiveIndex == 1, successTxt: riskCardActiveIndex == 2 }">
                        <span>风险等级：{{ currentActiveItem.riskLevel }}风险</span> <span style="margin-left: 30px">风险描述：{{ currentActiveItem.riskName }}</span
                        ><span style="margin-left: 40px">风险证据：{{ currentActiveItem.riskDesc }}</span>
                    </p>
                </div>
                <div class="content_bottom clearfix" v-loading="previewImgLoading">
                    <div class="preview_left fl">
                        <!-- 轮播图 start -->
                        <template v-if="imgUrlList && imgUrlList.length > 0">
                            <div class="imgCont">
                                <img-deal ref="imgDeal" :url="imageUrl"></img-deal>
                            </div>
                            <div class="preview_parent">
                                <i class="left-btn el-icon-arrow-left" @click="imgLeft()"></i>
                                <i class="right-btn el-icon-arrow-right" @click="imgRight()"></i>
                                <div class="preview-box">
                                    <ul class="Img_ul">
                                        <template v-for="(item, i) in imgUrlList">
                                            <li class="Img_li" :style="imgStyle" :key="item.id" @click="changeImg(item, i)">
                                                <!-- 图片样式 -->
                                                <template v-if="item.isImg && item.url">
                                                    <img :class="i === imgActiveIndex ? 'img_activeBorder' : ''" :src="item.url" @click="previewImg(item.url, i)" />
                                                </template>
                                                <!-- 非图片后缀样式 -->
                                                <template v-else-if="item.url">
                                                    <div :class="i === imgActiveIndex ? 'img_activeBorder img_none' : 'img_none'" @click="previewImg(item.url, i)">
                                                        <p style="margin: 4px 0">{{ item.suffix }}</p>
                                                        <p>!&nbsp;非图片文件</p>
                                                        <p style="margin-top: 5px">无法展示</p>
                                                    </div>
                                                </template>
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </template>
                        <!-- 轮播图 end -->
                        <!-- 重复案件号 -->
                        <div v-else-if="currentActiveItem && currentActiveItem.repeatCaseNos && currentActiveItem.repeatCaseNos.length > 0">
                            <el-table :data="currentActiveItem.repeatCaseNos" style="width: 100%" height="480">
                                <el-table-column :label="currentActiveItem.riskDesc" align="center">
                                    <template slot-scope="scope">
                                        <div class="repeat" @click="openCase(scope.row)">
                                            {{ scope.row }}
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="empty_box" v-else>{{ currentActiveItem.riskDesc ? currentActiveItem.riskDesc : '当前风险，暂无风险证据' }}</div>
                        <div class="img_list"></div>
                    </div>
                    <div class="preview_right fr">
                        <div class="right_title">案件风险：</div>
                        <template v-if="previewRiskData">
                            <template v-for="(items, index) in previewRiskData">
                                <!-- 高风险 -->
                                <div class="risk_card" :key="index + '100'" v-if="items.highCount > 0">
                                    <template v-if="items.highCount > 0">
                                        <div class="card_title errorTxt">高风险（{{ items.highCount }}）</div>
                                        <div :class="{ risk_box: 1, activeBox: riskCardActiveIndex == 0 }">
                                            <template v-for="(riskItem, riskIndex) in items.highRiskInfos">
                                                <div :class="{ risk: 1, autoP: 1, activeRisk: riskActiveIndex == riskIndex && riskCardActiveIndex == 0 }" :key="riskIndex + '10086'" @click="switchRiskImg(items.highRiskInfos, riskItem, riskIndex, 0)">
                                                    <el-tooltip v-if="riskItem && riskItem.riskName && riskItem.riskName.length > 10" effect="dark" :content="riskItem.riskName" placement="top-start">
                                                        <span>{{ riskItem.riskName ? riskItem.riskName.slice(0, 10) + '...' : '' }}</span>
                                                    </el-tooltip>
                                                    <span v-else>{{ riskItem.riskName }}</span>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                                <!-- 中风险 -->
                                <div class="risk_card" :key="index + '101'" v-if="items.mediumCount > 0">
                                    <template v-if="items.highCount > 0">
                                        <div class="card_title warningTxt">中风险（{{ items.mediumCount }}）</div>
                                        <div :class="{ risk_box: 1, activeBox: riskCardActiveIndex == 1 }">
                                            <template v-for="(riskItem, riskIndex) in items.mediumRiskInfos">
                                                <div :class="{ risk: 1, autoP: 1, activeRisk: riskActiveIndex == riskIndex && riskCardActiveIndex == 1 }" :key="riskIndex + '10087'" @click="switchRiskImg(items.mediumRiskInfos, riskItem, riskIndex, 1)">{{ riskItem.riskName }}</div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                                <!-- 低风险 -->
                                <div class="risk_card" :key="index + '102'" v-if="items.lowCount > 0">
                                    <template v-if="items.highCount > 0">
                                        <div class="card_title successTxt">低风险（{{ items.lowCount }}）</div>
                                        <div :class="{ risk_box: 1, activeBox: riskCardActiveIndex == 2 }">
                                            <template v-for="(riskItem, riskIndex) in items.lowRiskInfos">
                                                <div :class="{ risk: 1, autoP: 1, activeRisk: riskActiveIndex == riskIndex && riskCardActiveIndex == 2 }" :key="riskIndex + '10088'" @click="switchRiskImg(items.lowRiskInfos, riskItem, riskIndex, 2)">{{ riskItem.riskName }}</div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </template>
                        <span v-else>暂无数据</span>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import ImgDeal from '@/components/ImgDeal.vue';
export default {
    props: {
        previewRiskData: {
            typeof: Array,
            default: () => {
                return [];
            }
        }
    },
    components: {
        ImgDeal
    },
    data() {
        return {
            previewImgLoading: true,
            dialogVisible: true,
            imgUrlList: [],
            imgActiveIndex: 0, // 当前移动图片的索引值
            imgDistance: 0, // 移动的距离
            allDistance: 0, // 总移动距离
            imageUrl: '',
            previewShow: false,
            imgDialogVisible: false,
            riskActiveIndex: 0,
            riskCardActiveIndex: 0,
            currentActiveLength: 1,
            currentActiveItem: {},
            riskStr: { 0: 'highRiskInfos', 1: 'mediumRiskInfos', 2: 'lowRiskInfos' }
        };
    },
    computed: {
        imgStyle() {
            return {
                transform: `translate3d(${this.imgDistance}px, 0, 0)` // 计算移动的距离(x,y,z)
            };
        }
    },
    methods: {
        closeDialog() {
            this.$emit('closeRiskDialog', false);
        },
        openCase(caseNo) {
            const routeUrl = this.$router.resolve({
                path: '/caseInquiry/index',
                query: { caseNo: caseNo, query: 'query' }
            });
            window.open(routeUrl.href, '_blank');
        },
        changeImg(item, index) {
            this.imgActiveIndex = index;
            this.imageUrl = item.url;
            this.previewShow = true;
        },
        previewImg() {},
        imgLeft() {
            let tmpRiskVos = this.previewRiskData[0];
            if (this.imgActiveIndex > 0) {
                this.imgActiveIndex--; // 索引值-1
                // 切换大图预览
                this.changeImg(this.imgUrlList[this.imgActiveIndex], this.imgActiveIndex);
            } else {
                this.riskActiveIndex--;
                if (this.riskActiveIndex < 0) {
                    this.switchLeft();
                } else {
                    let currentRiskData = tmpRiskVos[this.riskStr[this.riskCardActiveIndex]];
                    this.switchRiskImg(currentRiskData, currentRiskData[this.riskActiveIndex], this.riskActiveIndex, this.riskCardActiveIndex);
                }
            }
            if (this.imgActiveIndex >= 4) {
                var index = 0;
                const temp = window.setInterval(() => {
                    // 利用定时器实现图片左右移动的动画效果
                    if (index < 33) {
                        // 移动次数(33次)
                        this.imgDistance += 2; // 每次向左移动的距离 (移动总距离为33*this.imgDistance)
                        index++;
                        return;
                    } else {
                        window.clearInterval(temp); // 移动完清除定时器
                    }
                }, 10);
            }
        },
        imgRight() {
            if (this.imgActiveIndex < this.imgUrlList.length - 1) {
                this.allDistance = 0;
                this.imgActiveIndex++;
                // 切换大图预览
                this.changeImg(this.imgUrlList[this.imgActiveIndex], this.imgActiveIndex);
                if (this.imgActiveIndex >= 5) {
                    this.allDistance = -66 * (this.imgActiveIndex - 4);
                    var index = 0;
                    const temp = window.setInterval(() => {
                        if (index < 33) {
                            this.imgDistance -= 2; // 每次向右移动的距离
                            index++;
                            return;
                        } else {
                            window.clearInterval(temp);
                        }
                    }, 10);
                }
            } else if (this.imgActiveIndex === this.imgUrlList.length - 1) {
                // 方框索引
                // riskCardActiveIndex
                // 当前选中项索引
                // riskActiveIndex
                // 方框中风险数量
                // currentActiveLength
                // 切回首项-高风险
                if (this.riskActiveIndex == this.currentActiveLength - 1) {
                    let highRiskInfos = this.previewRiskData[0].highRiskInfos;
                    this.riskCardActiveIndex = 0;
                    this.riskActiveIndex = 0;
                    // 列表,0项,当前风险索引0,高风险的索引=0
                    this.switchRiskImg(highRiskInfos, highRiskInfos[0], 0, 0);
                } else {
                    // 当前风险方框中,切换下个风险
                    this.riskActiveIndex++;
                    let tmpRiskVos = this.previewRiskData[0];
                    let currentRiskData = tmpRiskVos[this.riskStr[this.riskCardActiveIndex]];
                    this.switchRiskImg(currentRiskData, currentRiskData[this.riskActiveIndex], this.riskActiveIndex, this.riskCardActiveIndex);
                }
            }
        },
        switchLeft() {
            // 方框索引
            // riskCardActiveIndex
            // 当前选中项索引
            // riskActiveIndex
            // 方框中风险数量
            // currentActiveLength
            // 继续向前切换
            let tmpRiskVos = this.previewRiskData[0];
            if (this.riskActiveIndex <= 0) {
                this.riskCardActiveIndex--;
                if (this.riskCardActiveIndex < 0) {
                    // 切换至最后一个方框
                    this.riskCardActiveIndex = 2;
                    this.riskActiveIndex = 0;
                    let currentRiskData = tmpRiskVos[this.riskStr[this.riskCardActiveIndex]];
                    if (currentRiskData) {
                        this.switchRiskImg(currentRiskData, currentRiskData[currentRiskData.length - 1], currentRiskData.length - 1, this.riskCardActiveIndex);
                    } else {
                        this.switchLeft();
                    }
                } else {
                    // 向上一个方框切换
                    let currentRiskData = tmpRiskVos[this.riskStr[this.riskCardActiveIndex]];
                    if (currentRiskData) {
                        // 列表,0项,当前风险索引0,方框的索引
                        this.switchRiskImg(currentRiskData, currentRiskData[currentRiskData.length - 1], currentRiskData.length - 1, this.riskCardActiveIndex);
                    } else {
                        // 当前风险数=0时，页面不展示风险，自动向上切换
                        this.currentActiveLength = 1;
                        this.riskActiveIndex = 0;
                        this.switchLeft();
                    }
                }
            } else {
                // 向上一个风险切换
                this.riskActiveIndex--;
                let tmpRiskVos = this.previewRiskData[0];
                let currentRiskData = tmpRiskVos[this.riskStr[this.riskCardActiveIndex]];
                if (currentRiskData) {
                    this.switchRiskImg(currentRiskData, currentRiskData[this.riskActiveIndex], this.riskActiveIndex, this.riskCardActiveIndex);
                }
            }
        },
        switchRight() {
            // 方框索引
            // riskCardActiveIndex
            // 当前选中项索引
            // riskActiveIndex
            // 方框中风险数量
            // currentActiveLength
            // 继续向后切换
            let tmpRiskVos = this.previewRiskData[0];
            if (this.riskActiveIndex == this.currentActiveLength - 1) {
                this.riskCardActiveIndex++;
                if (this.riskCardActiveIndex > 2) {
                    // 切换至第一个方框
                    this.riskCardActiveIndex = 0;
                    this.riskActiveIndex = 0;
                } else {
                    // 切换下个风险方框切换
                    let currentRiskData = tmpRiskVos[this.riskStr[this.riskCardActiveIndex]];
                    if (currentRiskData) {
                        // 列表,0项,当前风险索引0,方框的索引
                        this.switchRiskImg(currentRiskData, currentRiskData[0], 0, this.riskCardActiveIndex);
                    } else {
                        // 当前风险数=0时，页面不展示风险，自动向下切换
                        this.currentActiveLength = 1;
                        this.riskActiveIndex = 0;
                        this.switchRight();
                    }
                }
            } else {
                // 当前风险方框中,切换下个风险
                this.riskActiveIndex++;
                let tmpRiskVos = this.previewRiskData[0];
                let currentRiskData = tmpRiskVos[this.riskStr[this.riskCardActiveIndex]];
                this.switchRiskImg(currentRiskData, currentRiskData[this.riskActiveIndex], this.riskActiveIndex, this.riskCardActiveIndex);
            }
        },
        switchRiskImg(riskItemList, riskItem, riskIndex, parentIndex) {
            this.previewImgLoading = false;

            // parentIndex 0-1-2  高-中-低
            this.imgUrlList = [];
            this.currentActiveLength = riskItemList.length;
            this.riskCardActiveIndex = parentIndex;
            this.riskActiveIndex = riskIndex;
            this.currentActiveItem = riskItem;
            if (riskItem.imageList) {
                this.imgUrlList = riskItem.imageList;
                this.changeImg(riskItem.imageList[0], 0);
            }
        }
    }
};
</script>
<style lang="less">
.preview_content {
    .content_top {
        .risk_txt {
            margin-bottom: 10px;
            margin-top: -20px;
            color: #333;
            font-weight: 600;
            font-size: 16px;
        }
    }
    .content_bottom {
        margin-top: 20px;
        height: 90%;
        .preview_left {
            width: 78%;
            min-height: 480px;
            padding-right: 20px;
            border-right: 1px solid #005bab;
            position: relative;

            .repeat {
                color: #005bab;
                cursor: pointer;
            }
            .imgCont {
                height: 480px;
            }
            .preview-box {
                margin-top: 20px;
            }
            .empty_box {
                width: 100%;
                height: 480px;
                text-align: center;
                line-height: 480px;
                color: #333;
            }
        }
        .preview_right {
            width: 20%;
            .right_title {
                color: #333;
                font-size: 18px;
                margin-bottom: 20px;
            }
            .risk_card {
                margin-bottom: 20px;
                .card_title {
                    font-size: 16px;
                }
                .risk_box {
                    border: 1px solid #cbcbcb;
                    border-radius: 4px;
                    padding: 10px;
                    margin-top: 10px;

                    .risk {
                        width: 90%;
                        height: 30px;
                        line-height: 30px;
                        color: #fff;
                        background: #666666;
                        border-radius: 20px;
                        text-align: center;
                        margin-bottom: 10px;
                        cursor: pointer;
                    }
                    .activeRisk {
                        background: #ff5f67 !important;
                    }
                    .risk:last-child {
                        margin-bottom: 0;
                    }
                }
                .activeBox {
                    border: 1px solid #333;
                }
            }
        }
    }
}
.errorTxt {
    color: #f56c6c;
}
.warningTxt {
    color: #e6a23c;
}
.successTxt {
    color: #409eff;
}
</style>